import React from 'react'
import PropTypes from 'prop-types'
import Tooltip from './Tooltip'
import InfoCircleFilledIcon from './icons/InfoCircleFilledIcon'
import InfoCircleOutlineIcon from './icons/InfoCircleOutlineIcon'

// Info icon and its tooltip, shared so React pages and Haml views read the same design.
const ICON_CLASSES = 'tw:h-3.5 tw:w-3.5 tw:text-gray-600'

const InfoTooltip = ({ content }) => (
  <Tooltip content={content}>
    <span aria-label={content} className="tw:group tw:flex tw:items-center" role="img">
      <InfoCircleOutlineIcon className={`${ICON_CLASSES} tw:group-hover:hidden`} />
      <InfoCircleFilledIcon className={`${ICON_CLASSES} tw:hidden tw:group-hover:block`} />
    </span>
  </Tooltip>
)

InfoTooltip.propTypes = {
  content: PropTypes.string.isRequired
}

export default InfoTooltip
